import {
	formatISOToReadable
} from '../../../../shared/lib/DateAndTieHelpers/fromISOToReadable'
import { snakeToSentence } from '../../../../shared/lib/caseConverters/snakeToSentence'
import { InstanceEventsContentCell } from './InstanceEventsContentCell'
import { InstanceEventContent } from '../../model/types/InstanceEvent'

interface Props {
	columnId: string
	value: unknown
}

export const InstanceEventsCell = ({ columnId, value }: Props) => {
	switch (columnId) {
		case 'updateTime':
			return <>{formatISOToReadable(value as string ?? '')}</>
		case 'eventName':
			return <>{snakeToSentence(value as string ?? '')}</>
		case 'content':
			return <InstanceEventsContentCell content={value as InstanceEventContent} />
		default:
			return <>{value ?? ''}</>
	}
}